function adjustHeight(className) {
  const elements = document.querySelectorAll(`.${className}`);
  
  // 初期化
  let maxHeight = 0;

  // 一番高さが大きい要素を見つける
  elements.forEach(element => {
    const height = element.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  // 他の要素の高さを一番高い要素に合わせる
  elements.forEach(element => {
    element.style.height = `${maxHeight}px`;
  });
}


// 画面がリサイズされた時に高さを調整する
window.addEventListener('resize', function() {
  adjustHeight('js-innerMenu-height');
  adjustHeight('js-matchHeight-restaurantCard');
});
// 初回
adjustHeight('js-innerMenu-height'); 
adjustHeight('js-matchHeight-restaurantCard'); 